import React, {ReactElement, useContext} from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import {useGetOrderConfirmationQuery} from '../../api/storesApi';
import Header from '../Header';
import Footer from '../Footer';
import OrderConfirmationHeader from './OrderConfirmationHeader';
import OrderConfirmationDetails from './OrderConfirmationDetails';
import OrderConfirmationSummary from './OrderConfirmationSummary';
import OrderConfirmationList from './OrderConfirmationList';
import {MobileContext} from '../../containers/MobileProvider';
import './index.scss';

type OrderConfirmationProps = {
  storeSlug: string;
  campaignId: string;
};

const OrderConfirmationPage: React.FC<OrderConfirmationProps> = ({
  storeSlug,
  campaignId
}: OrderConfirmationProps): ReactElement => {
  const {data} = useGetOrderConfirmationQuery({
    storeSlug,
    campaignId
  });
  const mobile = useContext(MobileContext);
  const orderConfirmationClasses = `orderConfirmation${
    mobile ? ' mobile' : ''
  }`;

  return (
    <div className={orderConfirmationClasses}>
      <Header storeSlug={storeSlug} />

      <Container className="orderConfirmation-body">
        <OrderConfirmationHeader />
        <div className="orderConfirmation-body-inner">
          <Grid container spacing={2} className="gridContainerTop">
            <Grid
              item
              lg={7}
              md={7}
              sm={12}
              xs={12}
              className="gridContainerTop-order">
              <OrderConfirmationDetails {...data} />
            </Grid>
            <Grid
              item
              lg={4}
              md={4}
              sm={12}
              xs={12}
              className="gridContainerTop-summary">
              <OrderConfirmationSummary {...data} />
            </Grid>
          </Grid>
          <Grid container className="orderList">
            <OrderConfirmationList {...data} />
          </Grid>
        </div>
      </Container>
      <Footer />
    </div>
  );
};

export default OrderConfirmationPage;
